import {Box} from "@material-ui/core";
import SpeedDial from "@material-ui/lab/SpeedDial/SpeedDial";
import PDFIcon from "@material-ui/icons/PictureAsPdf";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction/SpeedDialAction";
import React, {useState} from "react";
import EmailIcon from "@material-ui/icons/EmailRounded";
import PrintIcon from "@material-ui/icons/PrintRounded";
import ShowIcon from "@material-ui/icons/DesktopWindowsRounded";
import {Icon} from '@iconify/react';
import xlsxIcon from '@iconify-icons/mdi/file-excel';
import printJS from "print-js";
import {useSnackbar} from "notistack";
import {MailDialog} from "components/helpers/dialogs/mail.dialog";
import {PDFDialog} from "components/helpers/dialogs/pdf.dialog";
import {useEmailService} from "services/hooks";

export const ExportOptions = ({
        enableMail = false, enablePrint = false, enableShow = false, enableDownload = false, enableExcel = false,
        getPDF = () => {}, getExcel = () => {}, fileName, excelFileName, mailTo, mailCC, mailCCEnabled, mailSubject, mailBody,
        fabIcon = <PDFIcon/>,
        // Qué archivo se adjunta al mail: 'pdf' (getPDF / fileName) o 'excel' (getExcel / excelFileName).
        mailAttachment = 'pdf',
        // Validación previa a cada acción ('mail', 'print', 'pdf', 'excel', 'show'). Devuelve el mensaje
        // de error a mostrar o null si la acción puede ejecutarse.
        validate = () => null
    }) => {
    const [mailDialogOpen, setMailDialogOpen] = useState(false);
    const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [dialOpen, setDialOpen] = useState(false);

    const EmailService = useEmailService();
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();

    // fileName / excelFileName pueden ser un string o una función que devuelve el nombre;
    // la función se evalúa en cada uso (por ejemplo para incluir la fecha y hora de la descarga).
    const resolveName = name => typeof name === 'function' ? name() : name;

    // Print PDF
    const onPrintPDF = () => getPDF(blob => {
        const fileURL = URL.createObjectURL(blob);
        printJS(fileURL);
    });

    // Download PDF
    const onDownloadPdf = () => getPDF(blob => {
        const fileURL = URL.createObjectURL(blob);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = fileURL;
        a.download = resolveName(fileName);
        a.click();
        window.URL.revokeObjectURL(fileURL);
    });

    // Download Excel
    const onDownloadExcel = () => getExcel(blob => {
        const fileURL = URL.createObjectURL(blob);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = fileURL;
        a.download = resolveName(excelFileName);
        a.click();
        window.URL.revokeObjectURL(fileURL);
    });

    // Show PDF
    const onOpenPdfDialog = () => setPdfDialogOpen(true);
    const onClosePdfDialog = () => setPdfDialogOpen(false);

    const onShowPDF = () => getPDF(blob => {
        const fileURL = URL.createObjectURL(blob);
        setPdfUrl(fileURL);
        onOpenPdfDialog();
    });

    // Email
    const onOpenMailDialog = () => setMailDialogOpen(true);
    const onCloseMailDialog = () => setMailDialogOpen(false);

    const sendMail = mailData => {
        let sendMail = (blob) => {
            // Paso los parámetros a un formData para poder enviar el blob (attachment)
            var formData = new FormData();
            formData.append('attachment', blob);
            formData.append('data', JSON.stringify(mailData));

            EmailService.send(
                formData,
                response => {
                    onCloseMailDialog();
                    enqueueSnackbar('El email se envió correctamente', {variant: 'success'});
                },
                error => enqueueSnackbar(error, {variant: 'error'})
            );
        };

        if (mailData.attachFile)
            (mailAttachment === 'excel' ? getExcel : getPDF)((blob) => sendMail(blob));
        else
            sendMail();
    };

    // Dial
    const onDialOpen = () => setDialOpen(true);
    const onDialClose = () => setDialOpen(false);

    const dialActions = [
        {key: 'mail', icon: <EmailIcon/>, name: 'Enviar por Email', action: onOpenMailDialog, enabled: enableMail},
        {key: 'print', icon: <PrintIcon/>, name: 'Imprimir', action: onPrintPDF, enabled: enablePrint},
        {key: 'pdf', icon: <PDFIcon/>, name: 'Descargar PDF', action: onDownloadPdf, enabled: enableDownload},
        {key: 'excel', icon: <Icon icon={xlsxIcon} width={24}/>, name: 'Descargar Excel', action: onDownloadExcel, enabled: enableExcel},
        {key: 'show', icon: <ShowIcon/>, name: 'Ver en Pantalla', action: onShowPDF, enabled: enableShow},
    ];

    const onAction = action => {
        const error = validate(action.key);
        if (error)
            enqueueSnackbar(error, {variant: 'error'});
        else
            action.action();
    };

    return (
        <>
            <Box className='niquel-fab-btn'>
                <SpeedDial
                    ariaLabel="articulos"
                    icon={fabIcon}
                    onBlur={onDialClose}
                    onClick={onDialOpen}
                    onClose={onDialClose}
                    onFocus={onDialOpen}
                    onMouseEnter={onDialOpen}
                    onMouseLeave={onDialClose}
                    open={dialOpen}
                >
                    {dialActions.filter(action => action.enabled).map(action => (
                        <SpeedDialAction
                            key={action.name}
                            icon={action.icon}
                            tooltipTitle={action.name}
                            onClick={(e) => {
                                e.preventDefault();
                                onAction(action);
                            }}
                            className={'seba'}
                        />
                    ))}
                </SpeedDial>
            </Box>
            <MailDialog
                open={mailDialogOpen}
                onConfirm={sendMail}
                onCancel={onCloseMailDialog}
                fileName={resolveName(mailAttachment === 'excel' ? excelFileName : fileName)}
                attachFile={true}
                to={mailTo}
                cc={mailCC}
                ccEnabled={mailCCEnabled}
                subject={mailSubject}
                body={mailBody}
            />
            <PDFDialog
                open={pdfDialogOpen}
                onClose={onClosePdfDialog}
                pdfUrl={pdfUrl}
                pdfName={resolveName(fileName)}
            />
        </>
    )
}
